// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useTabsStore } from '../pinia/index' 
import Login from '../views/login.vue'
import MainLayout from '../layout/mainlayout.vue'
import home from '../views/home.vue'

// 建议创建一个简单的首页组件，或者复用 MainLayout 中的某个子组件
// 如果还没有 Home 组件，可以先创建一个空组件或重定向到现有页面
// import Home from '@/views/home.vue' 

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Login, // 【修复1】暂时使用 Login 组件，后续可替换为真正的 Home 组件
    meta: { title: '首页' }
  },
  {
    path: '/MainLayout',
    component: MainLayout,
   
  },
  // 【修复1补充】如果确实需要 /home 路径，可以单独定义或作为别名
  // {
  //   path: '/home',
  //   redirect: '/'
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// // 路由守卫
// router.beforeEach((to, from, next) => {
//   let tabsStore
//   try {
//     tabsStore = useTabsStore()
//   } catch (e) {
//     console.warn('Pinia store not ready yet', e)
//     return true // 【修复2】使用 return 代替 next()
//   }

//   const isAuthenticated = !!tabsStore.token

//   // 如果路由需要认证
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!isAuthenticated) {
//       // 【修复2】返回目标路径对象，代替 next({ path: ... })
//       return {
//         path: '/login',
//         query: { redirect: to.fullPath }
//       }
//     } else {
//       return true // 允许通过
//     }
//   } else {
//     // 如果已登录且访问登录页，重定向到首页
//     if (to.path === '/login' && isAuthenticated) {
//       // 【修复2】返回目标路径字符串，代替 next('/')
//       return '/'
//     } else {
//       return true // 允许通过
//     }
//   }
// })

export default router